import { schema } from 'normalizr';

const dashboardReport = new schema.Entity(
  'reports',
  {},
  {
    idAttribute: '_id',
  },
);

const dashboard = new schema.Entity(
  'dashboards',
  {
    reports: [dashboardReport],
  },
  {
    idAttribute: '_id',
    processStrategy: (dashboard) => ({ ...(dashboard || {}), loading: false }),
  },
);

const schemas = {
  GET_DASHBOARD_SCHEMA: { data: dashboard },
};

export default schemas;
